<div class="flex flex-col md:flex-row w-full h-full py-16 px-11">
  <div class="flex w-full md:w-5/12 flex-col items-start gap-6">
    <h1 class="text-primaryBlue">404</h1>
    <h3 class="text-secondaryBlue-500">Chắc sự cố ở đâu đó! Bạn vui lòng trở lại trang chủ nha</h3>
    <button routerLink="/" class="btn primary">Trang chủ</button>
  </div>
  <div class="bg-image w-full md:w-7/12 h-full"></div>
</div>
